module.exports = __webpack_public_path__ + "static/media/app-logo.f32139a6.png";